import { DateTime, Duration } from 'luxon';
import { InvitationsStatus } from '../models/invitation-status.model';

const DEFAULT_LANGUAGE = 'en';

/**
 * Maps an invitation status to its user-facing display text.
 */
export function getInvitationStatus(status: InvitationsStatus): string {
  let statusText: string = status;
  if (status === InvitationsStatus.ACCEPTEDALERT) {
    statusText = 'Accepted by different email';
  } else if (status === InvitationsStatus.ACTIVE) {
    statusText = 'Sent';
  }
  return statusText;
}

/**
 * Formats the remaining time until the given ISO date as a short, human-readable duration.
 */
export function getTimeLeft(endDate: string): string {
  const expiryDate = DateTime.fromISO(endDate);
  const currentDate = DateTime.now();
  const diff = expiryDate.diff(currentDate, ['days']);
  let expirationTime = diff.toObject();
  if (expirationTime.days && expirationTime.days <= 1) {
    expirationTime = expiryDate.diff(currentDate, ['hours', 'minutes']).toObject();
    expirationTime = { ...expirationTime, minutes: expirationTime.minutes ? Math.floor(expirationTime.minutes) : 0 };
  } else {
    expirationTime = { ...expirationTime, days: expirationTime.days ? Math.floor(expirationTime.days) : 0 };
  }
  return Duration.fromObject(expirationTime, { locale: DEFAULT_LANGUAGE }).toHuman({ unitDisplay: 'short' });
}
